import {GlobalExternalLinkEnum} from 'presentation/constants';

export const openGoogleMaps = (addressForMaps: string) => {
	if (!addressForMaps.trim()) return;

	window.open(
		`${GlobalExternalLinkEnum.GOOGLE_MAPS}/?q=${encodeURIComponent(addressForMaps)}`,
		'_blank',
		'noopener,noreferrer',
	);
};
